export const advancedSearchRoutes = [
  {
    path: '/search',
    name: 'advanced-search',
    meta: {
      requiresAuth: true // all app paths requires authentication
    },
    component: () => import(/* webpackChunkName: "advanced-search" */ './AdvancedSearch.vue')
  }
];
